require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-ride-engine-barrier-soft-helmet.json") })
        }
      }, "path---reviews-ride-engine-barrier-soft-helmet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-ride-engine-barrier-soft-helmet!./.cache/json/reviews-ride-engine-barrier-soft-helmet.json
// module id = 694
// module chunks = 231608221292675